/** Identical with the backend enum */
export enum PhoneTypeEnum {
    Mobile = 1,
    Home = 2,
    Work = 3,
    Other = 4
}
